import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
export const store =  new Vuex.Store({
  state: {
    count: 3,
    microphone_on: false,
    listening_on: false,
    recognition_on: false,
    recognition_disabled: true,
    chat_mode: 'audio_chat', // values: 'video_chat' || 'text_chat' || 'audio_chat'
    input_source: 'text', // values: 'text' or 'microphone'
    debug_on: false,
    video_index: {},
    video_id: null,
    demo_bot: {
      name: "..",
      profile_img: "",
      desc: ""
    }
  },
  mutations: {
    COUNT_INCREMENT(state) {
      state.count++;
    },
    COUNT_DECREMENT(state) {
      state.count--;
    },
    MIKE_ON(state) {
      state.microphone_on = true;
    },
    MIKE_OFF(state) {
      state.microphone_on = false;
    },
    LISTEN_ON(state) {
      state.listening_on = true;
    },
    LISTEN_OFF(state) {
      state.listening_on = false;
    },
    RECOGNITION_ON(state) {
      state.recognition_on = true;
    },
    RECOGNITION_OFF(state) {
      state.recognition_on = false;
    },
    SET_CHAT_MODE(state, new_mode) {
      state.chat_mode = new_mode;
      console.log("CHAT MODE CHANGED:", state.chat_mode)
    },
    SET_DEBUG_ON(state, new_value) {
      state.debug_on = new_value;
      console.log("DEBUG MODE CHANGED: IS ON:", state.debug_on)
    },
    RECOGNITION_DISABLED(state) {
      state.recognition_disabled = true;
      state.recognition_on = false;
    },
    RECOGNITION_ENABLED(state) {
      state.recognition_disabled = false;
    },
    SET_INPUT_SOURCE(state, new_source) {
      state.input_source = new_source;
    },
    SET_VIDEO_INDEX(state, new_index) {
      state.video_index = new_index;
    },
    SET_VIDEO_ID(state, video_id) {
      state.video_id = video_id;
    }
  },
  actions: {
    count_increment({commit}) {
      commit('COUNT_INCREMENT')
    },
    count_decrement({commit}) {
      commit('COUNT_DECREMENT')
    },
    listen_on({commit}) {
      commit('LISTEN_ON')
    },
    listen_off({commit}) {
      commit('LISTEN_OFF')
    },
    mike_on({commit}) {
      commit('MIKE_ON')
    },
    mike_off({commit}) {
      commit('MIKE_OFF')
    },
    set_chat_mode({commit}, new_chat_mode) {
      commit('SET_CHAT_MODE', new_chat_mode)
    },
    set_input_source({commit}, new_input_mode) {
      commit('SET_INPUT_SOURCE', new_input_mode)
    },
    set_debug_mode({commit}, debug_new_value) {
      console.log("STORE:  set debug state to ", debug_new_value);
      commit('SET_DEBUG_ON', debug_new_value)
    },
    recognition_on({commit}) {
      if (this.state.recognition_disabled) {
        console.log("Recognition can't turn on because microphone is disabled by user.")
      } else {
        commit('RECOGNITION_ON')
      }
    },
    recognition_off({commit}) {
      commit('RECOGNITION_OFF')
    },
    recognition_enabled({commit}) {
      commit('RECOGNITION_ENABLED')
    },
    recognition_disabled({commit}) {
      commit('RECOGNITION_DISABLED')
    },
    async get_video_index({commit}) {
      let mock_api = "https://us-central1-zack-vfkipo.cloudfunctions.net/getVideoIndex";
      let url = mock_api;
      const response = await fetch(url, {mode: 'cors'})
        .catch(error => {
          console.warn(error)
        });
      const index_data = await response.json();
      console.log("VIDEO INDEX RESULT:");
      console.dir(index_data)
      console.log("/VIDEO INDEX RESULT:");
      commit("SET_VIDEO_INDEX", index_data);
      let hello_response = index_data["hello"];
      if (hello_response) {
        let video_id = hello_response[0].v_id;
        commit("SET_VIDEO_ID", video_id);
      } else {
        alert("Failed to find the video id in the video index.");
      }
    }

    //TODO: recognition enabled and disabled should lock speech recognition off, or allow it.
  }
});
export default store;
